export default function formatCurrency(value) {
  if (value === null || value === undefined) {
    return '0.00';
  }

  // Convert the input to a number and then to a string to handle both string and number inputs
  const number = Number(value).toFixed(2);

  // Split the number into whole and decimal parts
  const parts = number.split('.');

  // Add a comma every three digits in the whole part
  const wholePart = parts[0];
  const formattedWholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Return the formatted whole part with the decimal part
  return `${formattedWholePart}.${parts[1]}`;
}
